export default {"src":"/_next/static/media/expat-logo-white.a554dcd0.svg","height":54,"width":160,"blurWidth":0,"blurHeight":0};